import { Box, Typography } from "@mui/material";
import React from "react";
import {
  CustomTableComponent,
  Column,
} from "../../../shared/elements/customTable.component";
import { RecentUser } from "../dto/dashboard.dto";
import { formatDateTime } from "../../../shared/utils/format.util";

export interface RecentUsersProps {
  data: RecentUser[];
}

const columns: Column[] = [
  { key: "fullName", label: "Nom complet" },
  { key: "email", label: "Adresse email" },
  {
    key: "createdAt",
    label: "Inscrit le",
    render: (value) => formatDateTime(value),
  },
];

export const RecentUsersComponent: React.FC<RecentUsersProps> = ({ data }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFDF7",
        borderRadius: "14px",
        padding: "18px 20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        flex: "1 1 380px",
        minWidth: 0,
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#333", mb: 1.5 }}>
        Derniers utilisateurs inscrits
      </Typography>
      {data.length === 0 ? (
        <Typography fontSize="0.8rem" color="gray">
          Aucun utilisateur pour le moment.
        </Typography>
      ) : (
        <CustomTableComponent columns={columns} rows={data} />
      )}
    </Box>
  );
};
